import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import logo from '../../assets/logo.png';
import { login } from '../../features/auth/auth.slice';
import Spinner from '../utilities/Spinner';

const Login = ({ setAuthType }) => {
  const [data, setData] = useState({
    email: '',
    password: '',
  });
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.auth);
  return (
    <>
      <>
        <img src={logo} alt="Postager Logo" />
        <p className="font-semibold">Login To Your Account</p>
      </>
      <form
        className="space-y-5 px-7 w-full pt-5"
        onSubmit={(e) => {
          e.preventDefault();
          dispatch(login(data));
        }}
      >
        <input
          type="email"
          className="bg-gray-50 border border-gray-400 text-gray-900 text-sm rounded-md focus:ring-blue-500 focus:border-blue-500 block w-full p-2"
          placeholder="Enter Your Email"
          onChange={(e) => {
            setData({
              ...data,
              email: e.target.value,
            });
          }}
          required
        />
        <div>
          <input
            type="password"
            className="bg-gray-50 border border-gray-400 text-gray-900 text-sm rounded-md focus:ring-blue-500 focus:border-blue-500 block w-full p-2"
            placeholder="Password"
            onChange={(e) => {
              setData({
                ...data,
                password: e.target.value,
              });
            }}
            required
          />
          <a
            href="#"
            className="text-sm pt-1 float-right mb-3 hover:underline"
            onClick={() => setAuthType('forgotpassword')}
          >
            Forgot Password
          </a>
        </div>

        <div className="flex flex-col justify-center items-center w-full space-y-3">
          <button
            className={`text-white   focus:ring-4 ${
              loading ? 'bg-blue-300' : 'bg-darkblue hover:bg-blue-800'
            } focus:outline-none focus:ring-blue-300 font-medium rounded-md text-sm w-full px-5 py-2 text-center self-center mt-5 flex justify-center`}
            type="submit"
            disabled={loading}
          >
            {loading ? <Spinner sm={true} /> : 'Login'}
          </button>
          <button className="text-black bg-white border border-gray-400 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-md text-sm w-[85%] px-5 py-2.5 text-center flex justify-center items-center">
            <img
              src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/google/google-original.svg"
              className="h-5 w-5 mr-1"
            />
            Login With Google
          </button>

          <a
            href="#"
            className="text-sm hover:underline"
            onClick={() => setAuthType('register')}
          >
            Don't Have An Account? Create Account
          </a>
        </div>
      </form>
    </>
  );
};

export default Login;
